export default __webpack_public_path__ + "static/media/BillDeskLogo.f56c59a9.png";